// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".absolute{position:absolute!important}.fixed{position:fixed!important}.relative{position:relative!important}.flex-basis-1{flex-basis:1!important}.flex-basis-0{flex-basis:0!important}.fill-width{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
